import { NavbarLink } from '../../types/navbar.type';
import { ValidationUtils } from '../../utils';
const vacasaUrl = ValidationUtils.validateAndGetEnvVar('REACT_APP_VACASA_URI');
const vacasaDomain = ValidationUtils.getDomain();
export const companyLinks: NavbarLink[] = [
    {
        id: 'navbar-aboutus',
        route: `${vacasaUrl}/about-us`,
        displayText: 'about_us',
        notifications: 0,
    },
    {
        id: 'navbar-leadership',
        route: `${vacasaUrl}/leadership`,
        displayText: 'leadership',
        notifications: 0,
    },
    {
        id: 'navbar-innovation',
        route: `${vacasaUrl}/innovation`,
        displayText: 'innovation',
        notifications: 0,
    },
    {
        id: 'navbar-newsroom',
        route: `${vacasaUrl}/press`,
        displayText: 'newsroom',
        notifications: 0,
    },
    {
        id: 'navbar-investors',
        route: `${vacasaUrl}/investors`,
        displayText: 'investors',
        notifications: 0,
    },
    {
        id: 'navbar-social-responsibility',
        route: `${vacasaUrl}/social-responsibility`,
        displayText: 'social_responsibility',
        notifications: 0,
    },
    {
        id: 'navbar-management-solutions',
        route: `${vacasaUrl}/property-management/solutions`,
        displayText: 'solutions_partnerships',
        notifications: 0,
    },
    {
        id: 'navbar-blog',
        route: `${vacasaUrl}/blog`,
        displayText: 'blog',
        notifications: 0,
    },
    {
        id: 'navbar-careers',
        route: `${vacasaUrl}/careers`,
        displayText: 'careers',
        notifications: 0,
    },
];

export const communityLinks: NavbarLink[] = [
    {
        id: 'navbar-social-responsibility',
        route: `${vacasaUrl}/social-responsibility`,
        displayText: 'social_responsibility',
        notifications: 0,
    },
    {
        id: 'navbar-accessibility',
        route: `${vacasaUrl}/accessibility`,
        displayText: 'accessibility',
        notifications: 0,
    },
];
